module.exports = __webpack_public_path__ + "assets/img/f685-nl.svg";